import { getOptionalChapterEntity } from "selectors/chapter/makeGetChapterEntity";
import { createSelector } from "reselect";
import getPlaybackState from "selectors/chapter/getPlaybackState";
import * as ChapterType from "utils/ChapterType";

const getCurrentQuestion = (state, ownProps) =>
  getPlaybackState(state, ownProps).currentQuestion;

const getIsProgressBarProgressHidden = createSelector(
  getCurrentQuestion,
  getOptionalChapterEntity,
  (currentQuestion, optionalChapterEntity) => {
    if (!optionalChapterEntity) {
      return false;
    }

    if (
      optionalChapterEntity.type === ChapterType.INTERVIEW &&
      !currentQuestion
    ) {
      // isPlayingInterviewIdleVideo
      return true;
    }

    return (
      optionalChapterEntity.type === "pathfinder" &&
      !optionalChapterEntity.introductionVideo
    );
  },
);

export default getIsProgressBarProgressHidden;
